// @flow
export { default } from './BoxEdit';
